import { Company, GetCompanyHookQuery } from 'API';
import { getCompanyHook } from 'graphql/customQueries';
import { useEffect, useState } from 'react';
import { client } from 'lib/graphql-client';
import { GraphQLResult } from '@aws-amplify/api';

const useGetCompany = (
  companyID?: string | null,
): Company | undefined => {
  const [company, setCompany] = useState(
    undefined as Company | undefined,
  );
  useEffect(() => {
    let ignore = false;

    const getCompany = async () => {
      const response = (await client.graphql({
        query: getCompanyHook,
        variables: {
          id: companyID,
        },
      })) as GraphQLResult<GetCompanyHookQuery>;

      if (!ignore && response.data?.getCompany) {
        setCompany(response.data.getCompany as Company);
      }
    };

    if (companyID) {
      getCompany();
    } else {
      setCompany(undefined);
    }

    return () => {
      ignore = true;
    };
  }, [companyID]);

  return company;
};

export default useGetCompany;
